import React from "react";
import { connect } from "dva";
import { modelUtils, Storage, jsonToString } from "../../../utils";
import { Spin } from "antd";
import "./styles.less";
import { utils_tool, component_tool, framework_tool } from "../../../tool";
let {
  WizCard,
  WizSearchBar,
  WizDataTable,
  WizButton,
  WizModalForm,
  WizAlert
} = component_tool;
let { WizContainer } = framework_tool;
let { getPageData } = utils_tool;

import createColumns from "./columns";

class UserManagement extends WizContainer {
  componentName = "UserManagement";

  constructor(props) {
    super(props);
    this.buildActionKey();
    this.state = {
      defaultSearch: true,
      apiParams: {},
      visible: false,
      record: null,
      selectedRows: 0,
      rows: []
    };
  }

  propsAndStateOnChange = {
    updateUser: this._userOnChange.bind(this),
    addUser: this._userOnChange.bind(this)
  };

  _userOnChange(nextProps, nextState) {
    this._getData();
    return true;
  }

  _componentDidMount = () => {
    if (this.state.defaultSearch) {
      this._getData();
    }
  };

  _getData(other = {}) {
    this.doAction({
      path: "userManagement/userList",
      payload: {
        key: "userListKey",
        apiParams: { ...this.state.apiParams, ...other }
      }
    });
  }

  _onUpdate = (record, other = {}) => {
    this.setState({
      record,
      visible: true,
      ...other
    });
  };

  _onDisabled = record => {};

  _onManagement = record => {};

  _submit = values => {
    if (values.id) {
      this.doAction({
        path: "userManagement/updateUser",
        payload: {
          key: "updateUser",
          apiParams: values
        }
      });
    } else {
      this.doAction({
        path: "userManagement/addUser",
        payload: {
          key: "addUser",
          apiParams: values
        }
      });
    }
    this.setState({
      record: null,
      visible: false
    });
  };

  _removeSelectedRows = ()=> {
    this.setState({
        selectedRows : 0,
        rows: [],
    })
  }

  _render() {
    const { userList, userManagementLoading } = this.props;
    let { record, visible, selectedRows, rows } = this.state;
    let dataItems = getPageData(userList.data);
    let other = {};
    let columns = createColumns(this, dataItems, other);
    let searchBarProps = {
      columns,
      onSearch: values =>
        this.setState({ apiParams: values }, () => {
          this._getData();
        })
    };
    let dataTableProps = {
      loading: userManagementLoading,
      columns,
      rowKey: "personId",
      dataItems,
      selectType: "checkbox",
      showNum: false,
      isScroll: true,
      onChange: ({ pageNum, pageSize }) => {
        this._getData({ current: pageNum, size: pageSize });
      },
      selectedRowKeys: rows.map(item => item.rowKey),
      onSelect: (keys, rows) => {
        this.keys = keys;
        this.setState({
            rows,
            selectedRows : rows.length
        })
      }
    };
    let modalFormProps = {
      loading: userManagementLoading,
      record,
      visible,
      columns,
      modalOpts: {
        width: 700
      },
      onCancel: () => {
        this.setState({
          record: null,
          visible: false
        });
      },
      onSubmit: values => {
        this._submit(values);
      }
    };
    return (
      <>
        <WizCard>
          <WizSearchBar
            type="grid"
            {...searchBarProps}
            cols={{ xs: 14, md: 12, xl: 10 }}
          />
        </WizCard>
        <WizCard className="mt-15">
          <WizButton.WizGroup>
            <WizButton
              title="新增"
              type="primary"
              onClick={e =>
                this.setState({
                  record: null,
                  visible: true
                })
              }
              icon="plus"
            >
              新增
            </WizButton>
            <WizButton
              title="重置密码"
              onClick={e => this.searchForm()}
              icon="redo"
            >
              重置密码
            </WizButton>
            <WizButton
              title="删除"
              type="danger"
              onClick={e => this.delete()}
              icon="delete"
              disabled={selectedRows < 1}
            >
              删除
            </WizButton>
          </WizButton.WizGroup>
          <WizAlert
            type="info"
            message={ <Message selectedRows = { selectedRows } removeSelectedRows = { this._removeSelectedRows } /> }
            showIcon
            style={{ marginBottom: 15 }}
          />
          <WizDataTable {...dataTableProps} />
          <div className="pagination">
            <WizDataTable.Pagination {...dataTableProps} />
          </div>
        </WizCard>
        <WizModalForm {...modalFormProps} />
      </>
    );
  }
}

const Message = ({selectedRows, removeSelectedRows}) => (
    <>
        已选择 { selectedRows } 项
        <WizButton
        style={{ height: 20 }}
        type="link"
        tooltip="清空"
        onClick={() => removeSelectedRows()}
        >
        {" "}
        清空
        </WizButton>
    </>
);

const mapStateToProps = (state, ownProps) => {
  const { userManagement } = state;
  const userList = modelUtils.getModelEntity(userManagement, "userListKey");
  const addUser = modelUtils.getModelEntity(userManagement, "addUser");
  const updateUser = modelUtils.getModelEntity(userManagement, "updateUser");
  const load = modelUtils.getLoadingState(state, "userManagement");
  return {
    userList: userList,
    addUser,
    updateUser,
    ...load
  };
};

export default connect(mapStateToProps)(UserManagement);
